import links from "@/links/links";
import qs from "qs";

export default {
  actions: {
    FETCH(agencyId) {
      return this.get(links.RESOLUTION_FETCH(), {
        dataKey: "hydra:member",
      });
    },
    // NOTE: get the ones that belong to certain resolution_catalog (relatedId = resolution_catalog_id)
    QUERY_FETCH(agencyId, queryParams, relatedId) {
      // NOTE: prepare query params
      var processedQueryParams = {};
      processedQueryParams["exists[parent_resolution]"] = false;
      // filters
      queryParams.filter.forEach(filter => {
        processedQueryParams[filter.column] = filter.value;
      });
      // order
      processedQueryParams[`order[${queryParams.sort.by}]`] = queryParams.sort.dir.toLowerCase();
      // page
      processedQueryParams.page = queryParams.page;
      return this.get(links.RESOLUTION_QUERY_FETCH(relatedId), {
        params: processedQueryParams,
        paramsSerializer: params => {
          return qs.stringify(params);
        },
        dataKey: "hydra:member",
      });
    },
    GET(id) {
      return this.get(links.RESOLUTION_GET(id));
    },
    POST(item) {
      return this.post(links.RESOLUTION_POST(), item);
    },
    PUT(item) {
      if (item.position) {
        item.position = parseInt(item.position);
      }
      return this.put(links.RESOLUTION_PUT(item.id), item);
    },
    DELETE(item) {
      return this.delete(links.RESOLUTION_DELETE(item.id), {
        delete: item.id,
      });
    },
    UPDATE_RESOLUTION_WITH_MEDIA(item) {
      return this.put(links.UPDATE_RESOLUTION_WITH_MEDIA(item.id), item);
    },
    CREATE_RESOLUTION_WITH_MEDIA(item) {
      return this.post(links.CREATE_RESOLUTION_WITH_MEDIA(), item);
    },
  },
};
